import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from './Auth';
import { GAME_PERMISSIONS, canAccess } from './permissions';

// ??????? ????????? (?? ????? GiPyramid ?? GiMayanPyramid)
import { FaPuzzlePiece, FaCalculator, FaSearch, FaBorderAll, FaPencilAlt, FaDice, FaSortAlphaDown } from 'react-icons/fa';
import { GiMaze, GiSnake, GiMayanPyramid } from 'react-icons/gi'; // ? ??? ??? ?????
import { MdLock } from 'react-icons/md';

const games = [
  // --- Free Games ---
  { id: 'maze', name: 'Maze Generator', path: '/maze', icon: <GiMaze size={50} color="#2ecc71" /> },
  { id: 'wordsearch', name: 'Word Search', path: '/wordsearch', icon: <FaSearch size={40} color="#3498db" /> },
  { id: 'math', name: 'Math Worksheets', path: '/math', icon: <FaCalculator size={40} color="#e67e22" /> },
  { id: 'wordscramble', name: 'Word Scramble', path: '/wordscramble', icon: <FaSortAlphaDown size={40} color="#9b59b6" /> },
  { id: 'pyramid', name: 'Number Pyramid', path: '/pyramid', icon: <GiMayanPyramid size={50} color="#f1c40f" /> }, // ? ?? ???????

  // --- Pro Games ---
  { id: 'sudoku', name: 'Sudoku Pro', path: '/sudoku', icon: <FaBorderAll size={40} color="#34495e" /> },
  { id: 'crossword', name: 'Crossword', path: '/crossword', icon: <FaPencilAlt size={40} color="#e74c3c" /> },
  { id: 'bingo', name: 'Bingo', path: '/bingo', icon: <FaDice size={40} color="#16a085" /> },
  { id: 'jigsaw', name: 'Jigsaw Puzzle', path: '/jigsaw', icon: <FaPuzzlePiece size={40} color="#d35400" /> },
  { id: 'snakes', name: 'Snakes & Ladders', path: '/snakes', icon: <GiSnake size={50} color="#27ae60" /> },
];

function Dashboard() {
  const { user } = useAuth();

  return (
    <div className="dashboard-container" style={{ padding: '40px 20px', background: '#f8f9fa', minHeight: '100vh' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        
        <header style={{ marginBottom: '40px', textAlign: 'center' }}>
          <h1 style={{ color: '#2c3e50', marginBottom: '10px' }}>Welcome back, {user?.name}! ??</h1>
          <p style={{ color: '#7f8c8d', fontSize: '18px' }}>Select a tool to start creating your puzzle book.</p>
        </header>

        <div className="games-grid" style={{ 
          display: 'grid', 
          gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))', 
          gap: '30px' 
        }}>
          {games.map((game) => {
            const requiredRole = GAME_PERMISSIONS[game.id] || 'pro';
            const isUnlocked = canAccess(user?.role, requiredRole);

            return (
              <div key={game.id} style={{ 
                background: 'white',
                borderRadius: '15px',
                padding: '30px 20px',
                textAlign: 'center',
                boxShadow: '0 10px 20px rgba(0,0,0,0.05)',
                transition: 'transform 0.3s ease',
                position: 'relative',
                border: isUnlocked ? 'none' : '2px dashed #e0e0e0',
                opacity: isUnlocked ? 1 : 0.8
              }}>
                <div style={{ marginBottom: '20px' }}>
                  {game.icon}
                </div>
                
                <h3 style={{ color: '#2c3e50', marginBottom: '20px', fontSize: '18px' }}>{game.name}</h3>

                {!isUnlocked && (
                  <div style={{ 
                    position: 'absolute', top: '15px', right: '15px', 
                    background: '#ff6b6b', color: 'white', 
                    padding: '5px 12px', borderRadius: '20px', 
                    fontSize: '12px', fontWeight: 'bold',
                    display: 'flex', alignItems: 'center', gap: '5px'
                  }}>
                    <MdLock /> PRO
                  </div>
                )}

                {isUnlocked ? (
                  <Link to={game.path} className="btn-primary" style={{ 
                    display: 'inline-block',
                    padding: '10px 25px',
                    background: '#3498db',
                    color: 'white',
                    borderRadius: '25px',
                    textDecoration: 'none',
                    fontWeight: 'bold',
                    boxShadow: '0 5px 15px rgba(52, 152, 219, 0.3)'
                  }}>
                    Open Tool
                  </Link>
                ) : (
                  <Link to="/pricing" style={{ 
                    display: 'inline-block',
                    padding: '10px 25px',
                    border: '2px solid #ff6b6b',
                    color: '#ff6b6b',
                    borderRadius: '25px',
                    textDecoration: 'none',
                    fontWeight: 'bold'
                  }}>
                    Upgrade to Unlock
                  </Link>
                )}
              </div>
            );
          })}
        </div>

      </div>
    </div>
  );
}

export default Dashboard;